import script from "./AnsweredList.vue?vue&type=script&setup=true&lang=js"
export * from "./AnsweredList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__